module.exports = __webpack_public_path__ + "img/BOHOL.12f47ae4.jpg";